import { ITransferExamsDatasource } from './../datasources/transfer_exams_datasource';
import { QueryMediator } from './../../../vendor/utility-ng-kernel/dist/core/query_mediator';
import { Exam } from './../builders/exam_builder';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';

angular.module('capability-ng-transfer').factory(
  'updateTransferExamCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferExamDatasource: ITransferExamsDatasource,
    $http: ng.IHttpService,
    transferMajorTileDelegate: any
  ): ICommand => {
    return defineCommand('updateTransferExamCommand', (deferred: ng.IDeferred<IQuery[]>, exam: Exam) => {
      $http({
        method: 'PATCH',
        url: `student/exam/${exam.id}`,
        data: {
          score: exam.score
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>) => {
          transferMajorTileDelegate.updateDegreeAudit();
          deferred.resolve();
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/update_transfer_exam_command.ts